<pbc-sorter [config]="TourenSorterConfig" [sorter]="touren.sorter$ | async" (sorterChange)="touren.sorter$.next($event)"></pbc-sorter>
